.riskHistoryTab {
    margin-top: 20px;
}